
function markerPoint(marker, map, point, google) {
  marker = new google.maps.Marker({
    position: new google.maps.LatLng(point.latitude, point.longitude),
    map: map,
    icon : point.icon,
    id : point.id,
  });
  return marker;
}

function infoToolTip(info, point, map, marker) {
  info.setContent(`<b>${point.name}</b><div>${point.address}</div>`);
  info.open(map, marker);
}

function markerPlace(placeLat, placeLng, google, map, iconDefault) {
  const markerAuto = new google.maps.Marker({
    position: new google.maps.LatLng(placeLat, placeLng),
    map: map,
    icon: iconDefault
  });
  return markerAuto;
}

function initPlacesAutoComplete(google, inputId, centerBound,  defaultBound, options = null) {
  if(!inputId) return;
  const autocompleteOptions = options || {
    bounds: {
      north: centerBound.lat + defaultBound,
      south: centerBound.lat - defaultBound,
      east: centerBound.lng + defaultBound,
      west: centerBound.lng - defaultBound,
    },
    componentRestrictions: { country: 'pt' },
    strictBounds: false,
  }
  // eslint-disable-next-line no-undef
  return new google.maps.places.Autocomplete(inputId, autocompleteOptions);
}

function mapPointCenter(dataPoints, inputCoordinates, points) {
  if (dataPoints)  {
    if (inputCoordinates.value != '') {
      const point = inputCoordinates.value.split(",");
      return { lat: parseFloat(point[0]), lng: parseFloat(point[1]) };
    } else {
      return { lat: 32.66012156, lng: -16.923758 };
    }
  } else {
    return { lat: points.latitude, lng: points.longitude };
  }
}

function placeChangedEvent(autocomplete, markersAll, google, inputLocation, inputCoordinates, map, iconDefault, form, zoom) {
  form.addEventListener('keypress', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
  });
  google.maps.event.addListener(autocomplete, 'place_changed', function () {
    const place = autocomplete.getPlace();
    if (!place.geometry) return;
    if (place.geometry) {
      const placeLat = place.geometry.location.lat();
      const placeLng = place.geometry.location.lng();
      const placeCoordinates = `${placeLat}, ${placeLng}`;
      inputCoordinates.value = placeCoordinates;

      // clear all marker place
      for (var f = 0; f < markersAll.length; f++ ) {
        markersAll[f].setMap(null);
      }
      const markerAuto = markerPlace(placeLat, placeLng, google, map, iconDefault);
      markerAuto.setPosition(place.geometry.location);
      markerAuto.setVisible(true);
      markersAll.push(markerAuto);
      map.setCenter(place.geometry.location);
      map.setZoom(zoom);
    } else {
      inputLocation.value = '';
      inputCoordinates.value = '';
    }
  });
}

function locateUser(locateBtn, google, inputCoordinates, map, iconDefault, markersAll, zoom, gpsInfo, btnGpsError, location) {
  locateBtn.addEventListener("click", () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude
        const lng = position.coords.longitude
        const latLng = new google.maps.LatLng(lat, lng);
        const geocoder = new google.maps.Geocoder();

        for (var f = 0; f < markersAll.length; f++ ) {
          markersAll[f].setMap(null);
        }
        geocoder.geocode({ 'latLng': latLng }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const currentLocation = results.shift();
            if (currentLocation) {
              const directionsStart = document.getElementById(location);
              directionsStart.value = currentLocation.formatted_address;
              const placeCoordinates = `${lat}, ${lng}`;
              inputCoordinates.value = placeCoordinates;
              const markerAuto = markerPlace(lat, lng, google, map, iconDefault);
              markerAuto.setPosition(latLng);
              markersAll.push(markerAuto);
              map.setCenter(latLng);
              map.setZoom(zoom);
            }
          }
        });
      },
      (error) => {
        const infoError = btnGpsError.getAttribute('data-error');
        const message = gpsInfo.querySelector('.messages');
        gpsInfo.removeAttribute('hidden');
        gpsInfo.removeAttribute('style');
        showError(error, message, infoError);
      });
    } else {
      const infoError = btnGpsError.getAttribute('data-support');
      const message = gpsInfo.querySelector('.messages');
      gpsInfo.removeAttribute('hidden');
      gpsInfo.removeAttribute('style');
      message.innerHTML = infoError;
    }
  });
}

function showError(error, alert, elementError) {
  switch(error.code) {
    case error.PERMISSION_DENIED:
      alert.innerHTML = elementError;
      break;
    case error.POSITION_UNAVAILABLE:
      alert.innerHTML = elementError;
      break;
    case error.TIMEOUT:
      alert.innerHTML = elementError;
      break;
    case error.UNKNOWN_ERROR:
      alert.innerHTML = elementError;
      break;
  }
}

function pointHtml(html, pointView, dataConsult, clockIcon, arrowIcon, i) {
  html =`<div class="col-12 pb-3">
    <div class="rounded border px-3 py-3">
      <div class="row no-gutters">
        <div class="col-auto">
          <img class="mr-2" src="${pointView[i].icon}" alt="${pointView[i].name}" />
        </div>
        <div class="col">
          <h6 class="h6 text-gray-dark mb-1 font-weight-600">${pointView[i].name}</h6>
          <div class="text-gray-dark content-address">${pointView[i].address}</div>
        </div>
      </div>`;
      if(pointView[i].statusSchedules) {
        html += `<div class="row">
          <div class="col-12">
            <div class="border-top mt-3 pt-3">
              <a class="link-show-point" href="${pointView[i].route}">
                <div class="row no-gutters align-items-center">
                  <div class="col-auto">
                    ${clockIcon}
                  </div>
                  <div class="col link-text font-size-xs font-weight-700">${dataConsult}</div>
                  <div class="col-auto ml-auto">
                    ${arrowIcon}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>`;
      }
    html +=`</div>
    </div>`;
  return html;
}

function emptyHtmlPoints(noResults) {
  const htmlEmpty =
  `<div class="col-12 ">
    <div class="rounded shadow mx-2 text-gray-dark text-center font-weight-700 px-3 py-3">
      ${noResults}
    </div>
  </div>`;
  return htmlEmpty;
}

function getPoints(google, a, points, i) {
  if (a == null || a == undefined) return null;
  const selected = [];
  for (i=0; i < points.length; i++) {
      if (a.contains(new google.maps.LatLng(points[i].latitude, points[i].longitude))) {
          selected.push(points[i]);
      }
  }
  return selected;
}

export {
  markerPoint, infoToolTip, markerPlace, initPlacesAutoComplete, mapPointCenter, placeChangedEvent, locateUser, pointHtml, emptyHtmlPoints, getPoints
};
